export default __webpack_public_path__ + "static/media/pic_orderstep_04.c53a45b2.png";